import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import * as fromDataset from 'src/app/modules/management/store/datasets';
import * as fromRsd from 'src/app/modules/cop/store/rsd';
import { Dataset, DatasetSubtype, DatasetType } from 'src/app/modules/core/store/models/dataset.model';
import { DocumentWriter, QueryParams } from 'src/app/modules/core/store/models';
import { DynamicField } from 'src/app/modules/core/components/fields/dynamic-field';
import { DocumentSchema, SystemFieldNames } from 'src/app/modules/core/store/models/document.model';
import { TranslateService } from '@ngx-translate/core';
import { DatasetApiService } from 'src/app/modules/management/store/datasets/dataset-api.service';
import { DataApiService } from 'src/app/modules/management/store/data/data-api.service';
import { catchError, filter, map, take} from 'rxjs/operators';
import { DatasetRelatedService } from 'src/app/modules/management/services/dataset-related.service';
import { cloneDeep } from 'lodash-es';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { GUID_EMPTY } from '@app/core/constants';
import { Store } from '@ngrx/store';

@Component({
    selector: 'topo-wizard-dialog',
    templateUrl: './wizard-dialog.component.html',
    styleUrls: ['./wizard-dialog.component.scss'],
    standalone: false
})
export class WizardDialogComponent implements OnInit, OnDestroy {
  @Input() showDialog: boolean;
  @ViewChild('header') headerElement: ElementRef;

  _dataset: Dataset = null;
  _fromDataset: Dataset = null;
  selectDatasetType: { type: DatasetType; subtype: DatasetSubtype } = null;
  selectDatasets: any[] = [];
  schema: DocumentSchema = null;
  wizardPages: any[];
  isOneCompletedWorkflowSteps: boolean;
  isMultipleCompletedWorkflowSteps: boolean;
  selectCompletedWorkflowSteps: any[] = [];
  uniqueWorkflowStep: any = null;
  multipleWorkflowSteps :any[] =[];
  selectedCompletedWorkflowStepUId: string | null = null;
  filteredCompletedWorkflowStepUId: string = null;
  selectedDatasetUId: string = null;
  _document: Document;
  singleDataset: boolean;
  guidEmpty = GUID_EMPTY;
  @Input() set datasets(datasets: any[]) {
    if (!!datasets && datasets.length) {
      this.selectDatasets = cloneDeep(datasets);
      this.singleDataset = false;
      this.selectDatasets.splice(0, 0, { uId: null, name: this.translate.instant('DASHBOARDS.SELECT-DATASET') });
      if (datasets.length === 1) {
        this.singleDataset = true;
        this._dataset = datasets[0];
        this.selectedDatasetUId = this._dataset.uId;
        this.datasetSelected.emit(this._dataset);
      }
    } else {
      this.selectDatasets = [{ uId: null, name: this.translate.instant('DASHBOARDS.LOADING') }];
    }
  }
  
  @Input() set document(document: Document) {
    if (this.showDialog) {
      this._document = document;
      this.initPages();
    }
  }

  @Input() set pages(pages: any) {
    if (this.showDialog) {
      this.wizardPages = pages;
      this.initPages();
    }
  }

  @Input() set fromDataset(value: Dataset) {
    this._fromDataset = value;
    
  }

  _fromDocument: Document;
  @Input() set fromDocument(value: Document) {
    
    this._fromDocument = value;
  }


  @Input() set alertCompletedWorkflowSteps(alertCompletedWorkflowSteps: any[]) {
    if (this.showDialog) {
      this.isOneCompletedWorkflowSteps = alertCompletedWorkflowSteps.length == 1;
      this.isMultipleCompletedWorkflowSteps = alertCompletedWorkflowSteps.length >= 2;

      this.uniqueWorkflowStep = alertCompletedWorkflowSteps[0];
      this.multipleWorkflowSteps = alertCompletedWorkflowSteps;
      this.initPages();
    }
  }
  @Input() title: string;
  @Input() sourceDataset: Dataset;
  @Input() sourceDocument: Document;
  @Output() datasetSelected: EventEmitter<any> = new EventEmitter();
  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();

  destroy$ = new Subject<void>();
  isActive: boolean;
  activePage: any;
  canNext: boolean = false;
  response: string;
  formInstructions: string;
  reportInstructions: string;
  refreshId: any;

  private initPages() {
    setTimeout(() => {
      this.headerElement?.nativeElement.focus();
    }, 1000);

    this.schema = null;
    this.activePage = null;
    if (!!this._dataset && !!this._document && !!this.wizardPages) {
      this.schema = this._dataset.schema;
      this.activePage = this.wizardPages?.length > 0 ? this.wizardPages[0] : null;
    }
  }

  get showCreate(): boolean {
    return this.activePage && this.activePage.view.uId === this.wizardPages[this.wizardPages.length - 1].view.uId;
  }

  get canCreate(): boolean {
    return !!this.activePage && this.isPageValid(this.activePage);
  }

  get showNext(): boolean {
    return this.activePage && this.activePage.view.uId !== this.wizardPages[this.wizardPages.length - 1].view.uId;
  }

  get showBack(): boolean {
    return this.activePage && (this.selectDatasets?.length > 2 || this.activePage.view.uId !== this.wizardPages[0].view.uId);
  }

  configureControl = (control: DynamicField): void => {
    if (control.field == null) {
      return;
    }
    const component = control.viewComponent;
    if (!!component.configuration?.isRequired) {
      control.displayName += ' *';
    }
  };

  getCanNext(page: any): boolean {
    return this.isPageValid(page);
  }

  private isPageValid(page: any): boolean {
    for (const control of page.controls.filter(c => !!c.viewComponent && c.viewComponent.configuration?.isRequired)) {
      if (control.value === null || control.value === undefined || control.value?.trim().length === 0) {
        return false;
      }
    }
    this.changeDetector.markForCheck();
    return true;
  }

  showView(page: any): boolean {
    return this.activePage && page.view.uId === this.activePage.view.uId;
  }

  showViewDesc(page: any): boolean {
    return page?.view?.configuration['pageDesc']?.trim().length > 0;
  }

  datasetChanged(dataset: any) {
    this._dataset = this.selectDatasets.find(d => d.uId === this.selectedDatasetUId);
    this.datasetSelected.emit(this._dataset);
  }
  
  completedWorkflowStepChanged() {
    const selectedWorkflowStep = this.multipleWorkflowSteps.find(d => d.uId === this.selectedCompletedWorkflowStepUId);
    this.filteredCompletedWorkflowStepUId = selectedWorkflowStep?.uId || null;
  }
  constructor(
    public translate: TranslateService,
    private datasetRelatedService: DatasetRelatedService,
    private changeDetector: ChangeDetectorRef,
    private datasetApiService: DatasetApiService,
    private dataApiService: DataApiService,
    private store: Store<fromDataset.State>
    
  ) {}

  ngOnInit(): void {
    this.refreshId = setInterval(() => {
      if (!!this.activePage) {
        this.canNext = this.getCanNext(this.activePage);
      }
    }, 200);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.refreshId) {
      clearInterval(this.refreshId);
    }
  }

  nextClick(): void {
    const index = this.wizardPages?.findIndex(p => p.view.uId === this.activePage.view.uId);
    if (index >= 0 && index < this.wizardPages?.length) {
      this.activePage = this.wizardPages[index + 1];
    }
  }

  backClick(): void {
    const index = this.wizardPages?.findIndex(p => p.view.uId === this.activePage.view.uId);
    if (index > 0) {
      this.activePage = this.wizardPages[index - 1];
    } else if (this.selectDatasets?.length > 2) {
      this._dataset = null;
      this.activePage = null;
      this.selectedDatasetUId = null;
    }
  }

  onClose(): void {
    this.wizardPages = [];
    this.activePage = null;
    this.close.emit();
  }

  saveClick(): void {
    this.activePage = null;
    const writer = new DocumentWriter(this._document);

    this.wizardPages.map(p => {
      for (const control of p.controls.filter(c => !!c.field)) {
        writer.setFieldValue(control.field.systemName, control.value);
      }
    });

    writer.setFieldValue(SystemFieldNames.uId, uuidv4());
    writer.setFieldValue('external_id', null);
    writer.setFieldValue(SystemFieldNames.dateCreated, moment());
    writer.setFieldValue(SystemFieldNames.createdBy, null);
    writer.setFieldValue(SystemFieldNames.provider, null);


    
  if (this.isMultipleCompletedWorkflowSteps) {

     var targetedWfStep;
      if (this.selectedCompletedWorkflowStepUId) {
      const selectedWorkflowStep = this.multipleWorkflowSteps.find(ws => ws.uId === this.selectedCompletedWorkflowStepUId);
      if (selectedWorkflowStep) {
        targetedWfStep = this.selectedCompletedWorkflowStepUId;

      }
    } else if (this.isOneCompletedWorkflowSteps && this.uniqueWorkflowStep) {

      targetedWfStep = this.uniqueWorkflowStep.uId;
    }
    var completedstep = this._fromDataset.workflow.workflowSteps.find(s => s.uId === targetedWfStep);
    if (completedstep != undefined) {
      var destDoc = cloneDeep(this._fromDocument);
      destDoc[SystemFieldNames.workflowStepUId] = targetedWfStep;
      this.store.dispatch(fromRsd.updateDocument({ dataset: this._fromDataset, document: destDoc }));

      this.store.select(fromRsd.selectSelectedDocumentState).pipe(
        filter(docState =>
          docState.document?.workflow_step_uid === destDoc.workflow_step_uid
        ),
        take(1)
      ).subscribe(() => {
        this.wizardPages = [];
        this.save.emit({ dataset: this._dataset, document: writer.document });
      });

    }
    } else {
      this.wizardPages = [];
      this.save.emit({ dataset: this._dataset, document: writer.document });


    }

  }
   
  private getDatasets(type: DatasetType, subtype: DatasetSubtype): Observable<any> {
    const queryParams: QueryParams = {
      skip: 0,
      take: 200,
      sortField: 'Name',
      sortDirection: 'Ascending',
      where: `type=${type} AND subType=${subtype} AND IsActive==true`
    };

    return this.datasetApiService.getDatasets(queryParams, true, true).pipe(
      catchError(e => {
        console.error(e);
        return of(null);
      }),
      map(res => {
        return res?.data;
      })
    );
  }
}
